<script lang="ts">
  import EventCard from '../../events/EventCard.svelte';
  import { CalendarService } from '$src/js/modules/calendar/services/CalendarService';
  import Svg from '$js/modules/ui/components/Svg.svelte';
  import type { R2REvent } from '$src/types/events';
  import jump from 'jump.js';
  import { onMount } from 'svelte';

  const calendarService = new CalendarService();
  const ITEMS_PER_PAGE = 9;

  let events = window.events;
  let currentPage = $state(1);

  let filteredEvents = $state<R2REvent[]>([]);
  let start = $state(0);
  let totalPages = $state(1);

  $effect(() => {
    filteredEvents = calendarService.filter(events);
    currentPage = 1;
  });

  $effect(() => {
    totalPages = Math.ceil(filteredEvents.length / ITEMS_PER_PAGE);
  });

  $effect(() => {
    start = (currentPage - 1) * ITEMS_PER_PAGE;
  });

  const scrollToTop = () => {
    jump('body', {
      duration: 300,
    });
  };

  const storePageNumberInHash = () => {
    window.location.hash = currentPage.toString();
  };

  const goToPage = (page: number) => {
    currentPage = page;
    storePageNumberInHash();
    scrollToTop();
  };

  const goToPreviousPage = () => {
    currentPage = Math.max(currentPage - 1, 1);
    storePageNumberInHash();
    scrollToTop();
  };

  const goToNextPage = () => {
    currentPage = Math.min(currentPage + 1, totalPages);
    storePageNumberInHash();
    scrollToTop();
  };

  onMount(() => {
    setTimeout(() => {
      if (window.location.hash) {
        const hashPageNumber = parseFloat(window.location.hash.substring(1));

        if (hashPageNumber > 0 && totalPages >= hashPageNumber) {
          currentPage = hashPageNumber;
        }
      }
    }, 200);
  });
</script>

{#each filteredEvents.slice(start, start + ITEMS_PER_PAGE) as event (event.slug)}
  <EventCard {event} mode="detail" />
{:else}
  <div>
    <p class="text-16px font-bold">
      Er zijn geen evenementen gevonden. Pas eventuele filtering aan.
    </p>
  </div>
{/each}

{#if totalPages > 1}
  <div class="2xl:fluid-gap-[8] mt-4 flex flex-wrap justify-center gap-2">
    <button
      title="Vorige pagina"
      class="2xl:fluid-w-[48] 2xl:fluid-h-[48] border-white-300 flex h-[48] w-[48] items-center justify-center border-1 disabled:opacity-20"
      onclick={goToPreviousPage}
      disabled={currentPage === 1}
    >
      <Svg
        image="chevron-left"
        width={20}
        height={20}
        className="2xl:fluid-w-[20] 2xl:fluid-h-[20] fill-[currentcolor]"
      />
    </button>
    {#each Array(totalPages) as _, i}
      <button
        class="2xl:fluid-w-[48] 2xl:fluid-h-[48] border-white-300 text-16px flex h-[48] w-[48] items-center justify-center border-1 font-medium transition-all {currentPage ===
        i + 1
          ? 'bg-primary text-black-1000 border-primary'
          : ''}"
        onclick={() => {
          goToPage(i + 1);
        }}
      >
        {i + 1}
      </button>
    {/each}
    <button
      title="Volgende pagina"
      class="2xl:fluid-w-[48] 2xl:fluid-h-[48] border-white-300 flex h-[48] w-[48] items-center justify-center border-1 disabled:opacity-20"
      onclick={goToNextPage}
      disabled={currentPage ===
        Math.ceil(filteredEvents.length / ITEMS_PER_PAGE)}
    >
      <Svg
        image="chevron-right"
        width={20}
        height={20}
        className="2xl:fluid-w-[20] 2xl:fluid-h-[20] fill-[currentcolor]"
      />
    </button>
  </div>
{/if}
